import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {roomsAction} from "../../roomsSlice";
import {RoutePath} from "../../../../../router/routerConfig/routerConfig";
import {NavigateFunction} from "react-router/dist/lib/hooks";

interface IRequestParams {
    idRoom: number,
    navigate: NavigateFunction
}

export const navigateRoomThunk = createAsyncThunk<void,
    IRequestParams,
    ThunkConfig<string>>(
        'rooms/navigateRoom',
        async ({idRoom, navigate}, thunkAPI) => {
            const {dispatch} = thunkAPI;

            dispatch(roomsAction.setIsLoadingRoom(true))
            try {
                navigate(`${RoutePath.room_view}${idRoom}/`)
            } finally {
                dispatch(roomsAction.setIsLoadingRoom(false))
            }
        },
    );
